import { render } from "./ModalDetailTender.vue?vue&type=template&id=783ae01a&scoped=true"
import script from "./ModalDetailTender.vue?vue&type=script&lang=js"
export * from "./ModalDetailTender.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-783ae01a"

export default script